"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryResultRenderer = void 0;
var react_1 = __importDefault(require("react"));
var combine_query_results_1 = require("./combine-query-results");
function QueryResultRenderer(_a) {
    var queryResults = _a.queryResults, 
    // @ts-ignore
    _b = _a.forwardProps, 
    // @ts-ignore
    forwardProps = _b === void 0 ? {} : _b, NoData = _a.NoData, Error = _a.Error, Data = _a.Data;
    var queryResult = (0, combine_query_results_1.combineQueryResults)(queryResults);
    switch (queryResult.status) {
        case 'no-data':
            return (react_1.default.createElement(NoData, { isFetching: queryResult.isFetching, props: forwardProps }));
        case 'error':
            return (react_1.default.createElement(Error, { isFetching: queryResult.isFetching, refetch: queryResult.refetch, props: forwardProps, error: queryResult.error }));
        case 'data':
            return (react_1.default.createElement(Data, { isFetching: queryResult.isFetching, refetch: queryResult.refetch, props: forwardProps, data: queryResult.data }));
    }
}
exports.QueryResultRenderer = QueryResultRenderer;
